export const BASE_STYLES = `
:root {
  --rl-panel-bg: #ffffff;
  --rl-panel-text: #13213a;
  --rl-accent: #0b5fff;
  --rl-border: #dbe4ff;
  --rl-overlay: rgba(5, 16, 34, 0.55);
  --rl-trigger-bg: #b96cbd;
  --rl-trigger-text: #ffffff;
  --rl-trigger-icon: #ffffff;
  --rl-trigger-border: #a75eab;
  --rl-trigger-shadow: 0 10px 30px rgba(0, 16, 45, 0.28);
  --rl-trigger-shadow-hover: 0 0 0 3px color-mix(in srgb, var(--rl-trigger-bg), #fff 72%);
  --rl-trigger-padding: 0 4px;
  --rl-trigger-margin: 20px;
  --rl-trigger-offset-x: 20px;
  --rl-trigger-offset-y: 20px;
  --rl-content-scale: 1;
  --rl-font-size-delta: 0px;
  --rl-line-height: 1.6;
  --rl-letter-spacing: 0px;
  --rl-reading-mask-height: 180px;
  --rl-reading-guide-height: 14px;
  --rl-cursor-black: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M4 2l11 24 3-8 8-3z'/%3E%3C/svg%3E"), auto;
  --rl-cursor-white: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath fill='%23fff' stroke='%23000' stroke-width='1.2' d='M4 2l11 24 3-8 8-3z'/%3E%3C/svg%3E"), auto;
}

#rl-root {
  position: fixed;
  inset: auto;
  z-index: 2147483000;
  --rl-trigger-margin: 20px;
  --rl-trigger-offset-x: 20px;
  --rl-trigger-offset-y: 20px;
  font-family:
    "Manrope",
    "Nunito Sans",
    "Segoe UI",
    -apple-system,
    BlinkMacSystemFont,
    "Helvetica Neue",
    Arial,
    sans-serif;
  line-height: 1.2;
}

#rl-trigger {
  position: fixed;
  left: var(--rl-trigger-offset-x);
  bottom: var(--rl-trigger-offset-y);
}

.rl-trigger-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--rl-trigger-border);
  background: var(--rl-trigger-bg);
  color: var(--rl-trigger-text);
  border-radius: 999px;
  min-width: 52px;
  min-height: 52px;
  padding: var(--rl-trigger-padding);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: var(--rl-trigger-shadow);
  line-height: 1;
}

.rl-trigger-icon {
  width: var(--rl-trigger-icon-size, 22px);
  height: var(--rl-trigger-icon-size, 22px);
  display: inline-block;
  background-color: var(--rl-trigger-icon-color, var(--rl-trigger-icon, currentColor));
  -webkit-mask: var(--rl-trigger-icon-url) center / contain no-repeat;
  mask: var(--rl-trigger-icon-url) center / contain no-repeat;
  flex: 0 0 auto;
}

.rl-trigger-label {
  white-space: nowrap;
}

.rl-variant-icon .rl-trigger-label {
  display: none;
}

.rl-variant-text .rl-trigger-icon {
  display: none;
}

.rl-trigger-button:hover,
.rl-trigger-button:focus-visible {
  outline: none;
  border-color: color-mix(in srgb, var(--rl-trigger-bg), #000 30%);
  box-shadow: var(--rl-trigger-shadow-hover);
}

#rl-root.rl-pos-bottom-left #rl-trigger {
  left: var(--rl-trigger-offset-x);
  right: auto;
  bottom: var(--rl-trigger-offset-y);
}

#rl-root.rl-pos-bottom-right #rl-trigger {
  right: var(--rl-trigger-offset-x);
  left: auto;
  bottom: var(--rl-trigger-offset-y);
}

#rl-root.rl-pos-top-left #rl-trigger {
  left: var(--rl-trigger-offset-x);
  right: auto;
  top: var(--rl-trigger-offset-y);
  bottom: auto;
}

#rl-root.rl-pos-top-right #rl-trigger {
  right: var(--rl-trigger-offset-x);
  top: var(--rl-trigger-offset-y);
  bottom: auto;
}

#rl-overlay {
  position: fixed;
  inset: 0;
  background: var(--rl-overlay);
  display: none;
}

#rl-root.rl-open #rl-overlay {
  display: block;
}

#rl-panel {
  position: fixed;
  top: 5vh;
  right: 20px;
  width: min(380px, calc(100vw - 32px));
  max-height: 90vh;
  display: none;
  flex-direction: column;
  background: var(--rl-panel-bg);
  color: var(--rl-panel-text);
  border: 2px solid var(--rl-border);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(6, 22, 49, 0.35);
}

#rl-root.rl-open #rl-panel {
  display: flex;
}

#rl-root.rl-pos-bottom-left #rl-panel,
#rl-root.rl-pos-top-left #rl-panel {
  left: 20px;
  right: auto;
}

#rl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
  background:
    linear-gradient(
      145deg,
      color-mix(in srgb, var(--rl-accent), #fff 92%),
      color-mix(in srgb, var(--rl-panel-bg), #fff 70%)
    );
  border-bottom: 1px solid var(--rl-border);
}

#rl-header-main {
  min-width: 0;
}

#rl-header-tools {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

#rl-language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.rl-lang-btn {
  border: 1px solid var(--rl-border);
  background: #fff;
  color: var(--rl-panel-text);
  border-radius: 999px;
  min-width: 30px;
  min-height: 30px;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
}

.rl-lang-btn img {
  width: var(--rl-lang-flag-size, 18px);
  height: var(--rl-lang-flag-size, 18px);
  border-radius: 999px;
  display: block;
}

.rl-lang-code {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.rl-lang-btn:hover,
.rl-lang-btn:focus-visible {
  outline: none;
  border-color: var(--rl-accent);
}

.rl-lang-btn.rl-active {
  border-color: var(--rl-accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--rl-accent), #fff 70%);
}

#rl-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
}

#rl-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--rl-panel-text), #fff 32%);
}

#rl-close {
  background: transparent;
  border: 0;
  color: var(--rl-panel-text);
  font-size: 18px;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
}

#rl-close:hover,
#rl-close:focus-visible {
  outline: none;
  background: color-mix(in srgb, var(--rl-accent), #fff 78%);
}

#rl-content {
  overflow: auto;
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.rl-section-title {
  margin: 6px 0;
  font-size: 15px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: color-mix(in srgb, var(--rl-panel-text), #000 20%);
}

.rl-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.rl-control {
  border: 2px solid var(--rl-border);
  border-radius: 12px;
  padding: 8px 10px;
  background: color-mix(in srgb, var(--rl-panel-bg), var(--rl-accent) 2%);
  color: inherit;
}

button.rl-control {
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
}

button.rl-control:hover,
button.rl-control:focus-visible {
  outline: none;
  border-color: var(--rl-accent);
}

button.rl-control.rl-active {
  background: color-mix(in srgb, var(--rl-accent), #fff 87%);
  border-color: var(--rl-accent);
}

.rl-spinner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-size: 13px;
}

.rl-spinner button {
  border: 1px solid var(--rl-border);
  background: #fff;
  border-radius: 8px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-weight: 800;
}

.rl-spinner button:hover,
.rl-spinner button:focus-visible {
  outline: none;
  border-color: var(--rl-accent);
}

.rl-spinner-value {
  min-width: 56px;
  text-align: center;
  font-weight: 700;
}

#rl-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px 16px;
  border-top: 1px solid var(--rl-border);
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--rl-panel-bg), #fff 5%),
      color-mix(in srgb, var(--rl-accent), #fff 97%)
    );
}

#rl-footer-actions {
  display: flex;
  gap: 8px;
}

#rl-footer-actions button {
  flex: 1;
  border: 2px solid var(--rl-border);
  background: var(--rl-panel-bg);
  color: var(--rl-panel-text);
  border-radius: 12px;
  min-height: 38px;
  font-weight: 700;
  cursor: pointer;
}

#rl-footer-actions button:hover,
#rl-footer-actions button:focus-visible {
  outline: none;
  border-color: var(--rl-accent);
}

#rl-branding {
  text-align: center;
  font-size: 11px;
  line-height: 1.35;
  color: color-mix(in srgb, var(--rl-panel-text), #fff 30%);
  text-decoration: none;
}

a#rl-branding:hover,
a#rl-branding:focus-visible {
  color: var(--rl-accent);
  outline: none;
}

readlygo-trigger,
[data-readlygo-trigger] {
  display: inline-flex;
  align-items: center;
}

.rl-inline-trigger {
  min-width: 42px;
  min-height: 42px;
  padding: 0 12px;
  font-size: 13px;
  box-shadow: none;
}

.rl-inline-trigger.rl-size-sm {
  min-width: 34px;
  min-height: 34px;
  padding: 0 10px;
  font-size: 12px;
}

.rl-inline-trigger.rl-size-lg {
  min-width: 48px;
  min-height: 48px;
  padding: 0 14px;
  font-size: 14px;
}

.rl-hidden {
  display: none !important;
}

#rl-reading-mask-top,
#rl-reading-mask-bottom {
  position: fixed;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.62);
  pointer-events: none;
  z-index: 2147482500;
}

#rl-reading-guide {
  position: fixed;
  left: 0;
  right: 0;
  height: var(--rl-reading-guide-height);
  pointer-events: none;
  background: color-mix(in srgb, var(--rl-accent), #fff 40%);
  border-top: 1px solid color-mix(in srgb, var(--rl-accent), #000 20%);
  border-bottom: 1px solid color-mix(in srgb, var(--rl-accent), #000 20%);
  z-index: 2147482600;
}

#rl-tts-fab {
  position: fixed;
  z-index: 2147482900;
  min-width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 2px solid var(--rl-border);
  background: var(--rl-panel-bg);
  color: var(--rl-panel-text);
  font-size: 16px;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

#rl-tts-fab:hover,
#rl-tts-fab:focus-visible {
  outline: none;
  border-color: var(--rl-accent);
}

html.rl-content-scaling {
  font-size: calc(100% * var(--rl-content-scale));
}

body.rl-font-sizing :where(h1, h2, h3, h4, h5, h6, p, li, a, span, label, input, textarea, select, button) {
  font-size: calc(1em + var(--rl-font-size-delta)) !important;
}

body.rl-line-height :where(h1, h2, h3, h4, h5, h6, p, li, a, span, label, input, textarea, select, button) {
  line-height: var(--rl-line-height) !important;
}

body.rl-letter-spacing :where(h1, h2, h3, h4, h5, h6, p, li, a, span, label, input, textarea, select, button) {
  letter-spacing: var(--rl-letter-spacing) !important;
}

body.rl-readable-font :where(h1, h2, h3, h4, h5, h6, p, li, a, span, label, input, textarea, select, button) {
  font-family: "Atkinson Hyperlegible", "Segoe UI", Arial, sans-serif !important;
}

body.rl-dyslexia-font :where(h1, h2, h3, h4, h5, h6, p, li, a, span, label, input, textarea, select, button) {
  font-family: "OpenDyslexic", "Comic Sans MS", "Segoe UI", Arial, sans-serif !important;
}

body.rl-align-left :where(h1, h2, h3, h4, h5, h6, p, li, blockquote, figcaption) {
  text-align: left !important;
}

body.rl-align-center :where(h1, h2, h3, h4, h5, h6, p, li, blockquote, figcaption) {
  text-align: center !important;
}

body.rl-align-right :where(h1, h2, h3, h4, h5, h6, p, li, blockquote, figcaption) {
  text-align: right !important;
}

html.rl-dark-contrast {
  filter: invert(1) hue-rotate(180deg) contrast(1.1);
}

html.rl-dark-contrast img,
html.rl-dark-contrast video,
html.rl-dark-contrast svg,
html.rl-dark-contrast canvas,
html.rl-dark-contrast iframe {
  filter: invert(1) hue-rotate(180deg);
}

html.rl-light-contrast {
  filter: brightness(1.08) contrast(1.3);
}

html.rl-monochrome {
  filter: grayscale(1);
}

html.rl-high-saturation {
  filter: saturate(1.8);
}

html.rl-high-contrast {
  filter: contrast(1.65);
}

html.rl-low-saturation {
  filter: saturate(0.45);
}

body.rl-highlight-titles :where(h1, h2, h3, h4, h5, h6) {
  outline: 2px dashed color-mix(in srgb, var(--rl-accent), #000 15%) !important;
  outline-offset: 4px !important;
}

body.rl-highlight-links :where(a, button, [role="button"]) {
  background: color-mix(in srgb, var(--rl-accent), #fff 80%) !important;
  text-decoration: underline !important;
  text-decoration-thickness: 2px !important;
}

body.rl-highlight-hover *:hover {
  outline: 2px dashed color-mix(in srgb, var(--rl-accent), #000 20%) !important;
  outline-offset: 2px !important;
}

body.rl-highlight-focus *:focus {
  outline: 3px solid var(--rl-accent) !important;
  outline-offset: 3px !important;
}

body.rl-hide-images :where(img, picture, figure, svg, canvas, video) {
  visibility: hidden !important;
}

body.rl-hide-emoji :where(img.emoji, span[role="img"], i.emoji, .emoji) {
  display: none !important;
}

body.rl-big-black-cursor,
body.rl-big-black-cursor * {
  cursor: var(--rl-cursor-black) !important;
}

body.rl-big-white-cursor,
body.rl-big-white-cursor * {
  cursor: var(--rl-cursor-white) !important;
}

@media (max-width: 768px) {
  #rl-panel {
    right: 8px;
    left: 8px;
    width: auto;
    max-height: 88vh;
    top: auto;
    bottom: 10px;
  }
  #rl-root.rl-pos-bottom-left #rl-trigger {
    left: var(--rl-trigger-offset-x);
    right: auto;
    bottom: var(--rl-trigger-offset-y);
  }
  #rl-root.rl-pos-bottom-right #rl-trigger {
    right: var(--rl-trigger-offset-x);
    left: auto;
    bottom: var(--rl-trigger-offset-y);
  }
  #rl-root.rl-pos-top-left #rl-trigger {
    left: var(--rl-trigger-offset-x);
    right: auto;
    top: var(--rl-trigger-offset-y);
    bottom: auto;
  }
  #rl-root.rl-pos-top-right #rl-trigger {
    right: var(--rl-trigger-offset-x);
    left: auto;
    top: var(--rl-trigger-offset-y);
    bottom: auto;
  }
  .rl-grid {
    grid-template-columns: 1fr;
  }
}
`;

export function applyThemeVariables(theme) {
  if (!theme) {
    return;
  }
  const root = document.documentElement;
  if (theme.panelBg) {
    root.style.setProperty("--rl-panel-bg", String(theme.panelBg));
  }
  if (theme.panelText) {
    root.style.setProperty("--rl-panel-text", String(theme.panelText));
  }
  if (theme.accent) {
    root.style.setProperty("--rl-accent", String(theme.accent));
  }
  if (theme.border) {
    root.style.setProperty("--rl-border", String(theme.border));
  }
  if (theme.overlay) {
    root.style.setProperty("--rl-overlay", String(theme.overlay));
  }
  if (theme.triggerBg) {
    root.style.setProperty("--rl-trigger-bg", String(theme.triggerBg));
  }
  if (theme.triggerText) {
    root.style.setProperty("--rl-trigger-text", String(theme.triggerText));
  }
  if (theme.triggerIcon) {
    root.style.setProperty("--rl-trigger-icon", String(theme.triggerIcon));
  }
  if (theme.triggerBorder) {
    root.style.setProperty("--rl-trigger-border", String(theme.triggerBorder));
  }
  if (theme.triggerShadow) {
    root.style.setProperty("--rl-trigger-shadow", String(theme.triggerShadow));
  }
  if (theme.triggerShadowHover) {
    root.style.setProperty("--rl-trigger-shadow-hover", String(theme.triggerShadowHover));
  }
  if (theme.triggerPadding) {
    root.style.setProperty("--rl-trigger-padding", String(theme.triggerPadding));
  }
  if (theme.triggerMargin) {
    root.style.setProperty("--rl-trigger-margin", String(theme.triggerMargin));
    root.style.setProperty("--rl-trigger-offset-x", String(theme.triggerMargin));
    root.style.setProperty("--rl-trigger-offset-y", String(theme.triggerMargin));
  }
  if (theme.triggerOffsetX) {
    root.style.setProperty("--rl-trigger-offset-x", String(theme.triggerOffsetX));
  }
  if (theme.triggerOffsetY) {
    root.style.setProperty("--rl-trigger-offset-y", String(theme.triggerOffsetY));
  }
}
